import { useQuery } from "@tanstack/react-query";
import { fileApi } from "~/api";

const useTaskByPath = (path: string) =>
  useQuery({
    queryKey: ["task", "by-path", path],
    queryFn: async () => {
      const res = await fileApi.client.GET("/api/Task/path", {
        params: { query: { path } },
      });
      if (res.response.status === 404) return null; // path is free
      if (res.error) throw res.error;
      return res.data ?? null;
    },
    enabled: !!path,
    retry: false,
    staleTime: 0,
  });

export const usePathValidation = (path: string | undefined, currentTaskId?: number) => {
  const trimmedPath = path?.trim() ?? "";
  const { data: existingTask, isLoading } = useTaskByPath(trimmedPath);

  const error =
    existingTask && existingTask.id !== currentTaskId
      ? `A task already exists for this folder ("${existingTask.name}")`
      : undefined;

  return { error, isChecking: isLoading };
};
